const ROLFS_IMAGE_URL = 'https://lvj1vt15bh.execute-api.eu-north-1.amazonaws.com'

export {
  ROLFS_IMAGE_URL,
}
